import * as React from 'react';

import * as courseInvitation from '../styles/courseInvitation.module.scss';

export const CourseInvitation = () => {
  return (
    <section className={courseInvitation.courseInvitation}>
      <div className={'container'}>
        <div className={courseInvitation.courseInvitation__wrapper}>
          <div className={courseInvitation.courseInvitation__confetti}>
            <p className={courseInvitation.courseInvitation__title}>
              Пройдите наш онлайн-курс по изучению грамматики английского языка!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
